/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import {Module, Node} from "@msdyn365-commerce-modules/utilities";
import * as React from "react";
import {IAccordionViewProps} from "@msdyn365-commerce-modules/accordion/";

const accordionView: React.FC<IAccordionViewProps> = (props) => {
  const {heading, AccordionContainer, accordionItems} = props;

  if (!props.heading && !props.accordionButtons && !props.accordionItems) {
    props.context.telemetry.error(
      "Accordion content is empty, module wont render",
    );
    return null;
  }
  if (props.context.request.user.isAuthenticated) {
    return (
      <Module {...AccordionContainer}>
        <Node {...props.HeaderSection}>
          <Node {...props.HeadingWrapper}>{heading}</Node>
          {props.accordionButtons && (
            <Node {...props.accordianButtonsContainer}>
              {props.accordionButtons}
            </Node>
          )}
        </Node>
        <Node {...props.accordionItemContainer}>{accordionItems}</Node>
      </Module>
    );
  }
  return null;
};

export default accordionView;
